import i18n from '@/localization';
import { i18nMap } from '@/data/translationMapper';

export function translateI18nValues<T>(data: T, lang?: 'en' | 'it' | string): T {
  if (typeof data === 'string') {
    if (data.startsWith('i18n') && i18nMap[data]) {
      const entry = i18nMap[data];
      // Fall back rather than return undefined: a caller that cannot supply a language — an error
      // transform, say — used to make the message vanish from the screen, which is worse than
      // showing the raw key.
      const active = i18n.language ?? '';
      return (entry[lang ?? ''] ?? entry[active] ?? entry[active.slice(0, 2)] ?? entry['en'] ?? data) as T;
    }
    return data as T;
  }

  if (Array.isArray(data)) {
    return data.map((item) => translateI18nValues(item, lang)) as T;
  }

  if (data !== null && typeof data === 'object') {
    const result: any = {};
    for (const key in data) {
      result[key] = translateI18nValues((data as any)[key], lang);
    }
    return result;
  }

  // number, boolean, null, undefined
  return data;
}
